function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoinbaseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 800 600"
    },
    viewBox: "0 0 800 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M399.8 69.1c127.3 0 230.5 103.2 230.5 230.5S527.1 530.1 399.8 530.1 169.3 426.9 169.3 299.6 272.5 69.1 399.8 69.1z",
    style: {
      fill: "#0052ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.9 380.6c-44.8 0-81-36.3-81-81s36.3-81 81-81c40.1 0 73.4 29.2 79.8 67.5h81.6c-6.9-83.2-76.5-148.6-161.5-148.6-89.5 0-162.1 72.6-162.1 162.1s72.6 162.1 162.1 162.1c85 0 154.6-65.4 161.5-148.6h-81.7c-6.4 38.3-39.6 67.5-79.7 67.5z",
    style: {
      fill: "#fff"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbaseLogo);
export default __webpack_public_path__ + "static/media/coinbase-logo.2f69579a78ee79748dafbc130fa0db43.svg";
export { ForwardRef as ReactComponent };